import React from 'react';

interface CardProps {
    title?: string;
    className?: string;
    bodyClassName?: string;
    style?: React.CSSProperties;
    children: React.ReactNode;
}

const Card: React.FC<CardProps> = ({ title, className = '', bodyClassName = '', style, children }) => {
    return (
        <div className={`card ${className}`} style={style}>
            {title && (
                <div className="card-header">
                    <h5 className="card-title">{title}</h5>
                </div>
            )}
            <div className={`card-body ${bodyClassName}`.trim()}>
                {children}
            </div>
        </div>
    );
};

export default Card;
